import lang from 'dojo/_base/lang';
import topic from 'dojo/topic';
import { compose, mdsWidget } from 'dojo/_base/declare';
import { NotificationTopics, NotificationTypes } from "./NotificationTypes";
import _WidgetBase from 'dijit/_WidgetBase';
import RequestManager from 'more/RequestManager';
import { DateHelpers, FeatureHelpers } from "../../../more/Helpers";
import methodHooks from 'more/mdsMethodHooks';
//import Edit = require("../../UI/Edit/Edit");
//import "../../UI/Edit/Edit";
//import Button = require("../../UI/Button/Button");
//import "../../UI/Button/Button";
//import GenericDialog = require("../../UI/GenericDialog/GenericDialog");
//import "../../UI/GenericDialog/GenericDialog";
//import DataItems = require("DataItems");


class NotificationListener extends methodHooks(compose(_WidgetBase)) {
    private requestManager: RequestManager = null;
    private _requestData: NotificationTypes.PullRequestData;

    private _pullIntervalHandle: number = null;
    private _settings: NotificationTypes.ModuleSettings = {
        InitialPullDelay: 300,
        PullInterval: 600000,
        NotificationCenterTargetnode: "egal"
    };

    private allLoadedNotifications: Array<NotificationTypes.NotificationEntity_Base>;
    private _topics: Array<dojo.Handle> = [];

    // diverse Nodes:

    getNotifications(): Array<NotificationTypes.NotificationEntity_Base> {
        if (!this._requestData || !this._requestData.earliestDate || DateHelpers.getDiffMinutes(this._requestData.earliestDate, new Date()) >= 5){
            this.loadNotifications();
        }
        return this.allLoadedNotifications;
    }

    loadNotifications(): void {
        
        //this._requestData.timeStamp = new Date; // Zeitstempel auf JETZT stellen

        //console.log(this.id + " - Request", this._requestData);

        this.requestManager.callfunction(
            "Webtool_API_Notification__LoadNotificationList",
            this._requestData,
            lang.hitch(this, this._onLoadNotificationsResponse),
            lang.hitch(this, this._onLoadNotificationsError)
        );
    }

    private _onUpdatedNotification(data: NotificationTypes.NotificationEntity_Base) {
        if (!data) return;

        let index = this.getNotificationIndexById(data.ID);
        if (index) {
            this.allLoadedNotifications[index] = data;

            
            topic.publish(NotificationTopics.Updated_Single + data.ID, data);
        }
    }

    private _onLoadNotificationsResponse(response: more.PackedEntitylistResult<NotificationTypes.NotificationEntity_Base>/*response: NotificationTypes.PullResponseData*/): void {
        //console.log(this.id + " _onLoadNotificationsResponse", response);

        let newNotifications: Array<NotificationTypes.NotificationEntity_Base> = [];
        let updatedNotifications: Array<NotificationTypes.NotificationEntity_Base> = [];

        let results: Array<NotificationTypes.NotificationEntity_Base> = response.entitylist;
        

        //this.emit("notificationsLoaded"); // usw ... evtl noch wie viele neu sind und obs überhaupt welche gibt

        for (let notification of results) {
            //let notification: NotificationTypes.NotificationEntity_Base = results[i];
            let notificationId: string = notification.ID;

            // prüfen obs die Notification schon gibt oder obs ein Update dafür gibt?
            let existingIndex: number = this.getNotificationIndexById(notificationId);
            if (existingIndex != -1) {
                updatedNotifications.push(notification);
            } else {
                newNotifications.push(notification);
            }            
        }

        this.allLoadedNotifications = results;

        topic.publish(NotificationTopics.Loaded, this.allLoadedNotifications);
        topic.publish(NotificationTopics.Updated_List, updatedNotifications);
        

        //this._requestData.earliestDate = new Date(); // nächstes Datum auf "jetzt" setzen

        this.showError("");
    }

    getUnreadNotifications(): Array<NotificationTypes.NotificationEntity_Base> {
        let result = this.allLoadedNotifications.filter(data => data.is_read != true);

        return result;
    }
    getUnconfirmedNotifications(): Array<NotificationTypes.NotificationEntity_Base> {
        let result = this.allLoadedNotifications.filter(data => data.is_confirmation_needed == true && data.is_confirmed != true);

        return result;
    }

    private _onLoadNotificationsError(error: more.requestErrorMessage): void {
        //this.showError(error.Message);

        console.error(this.id + " _onLoadNotificationsError", error.url, error.Message);

        if (error.Message?.indexOf("Webtool_API_Notification__LoadNotificationList") != -1) {
            // deutet auf einen grundsätzlichen Fehler mit der API hin.
            // Intervall beenden!
            if (this._pullIntervalHandle) clearInterval(this._pullIntervalHandle);
        }
    }

    getNotificationByID(ID: string): NotificationTypes.NotificationEntity_Base {
        let index: number = this.getNotificationIndexById(ID);

        if (index != -1) {
            return this.allLoadedNotifications[index];
        }

        return null;
    }

    private getNotificationIndexById(ID: string): number {
        for (let i = 0; i < this.allLoadedNotifications.length; i++) {
            if (this.allLoadedNotifications[i].ID == ID) {
                return i;
            }
        }

        return -1;
    }

    private showError(notification?: string) {
        if (!notification) {
            
        } else {
            alert(notification);
        }
    }

    private _onSessionData(data?: any): void {
        //console.debug("NotificationListener - _onCheckSession", data);

        if (typeof (data) == "object" && !!data) {
            if (data.result == null) {
                this._onCloseSession();
            } else if (typeof (data.result) == "object") {
                this._onOpenSession();
            }
        } else {
            this._onCloseSession();
        }
    }

    private _onOpenSession(): void {

        //console.debug("NotificationListener - onOpenSession");
        if (FeatureHelpers.hasFeature("Notifications", "AutomaticListener")) {

            if (this._pullIntervalHandle == null) { // noch bissl unsauber: wir kommen hier recht oft her, daher so abfangen damit das nicht zigmal passiert
                if (this._settings.InitialPullDelay > 0) {
                    setTimeout(lang.hitch(this, this.loadNotifications), this._settings.InitialPullDelay);
                } else {
                    this.loadNotifications();
                }
            }

            if (this._settings.PullInterval != null && this._settings.PullInterval > 0 && this._pullIntervalHandle == null) {
                //console.debug("Notification Listener - start Interval");
                this._pullIntervalHandle = setInterval(lang.hitch(this, this.loadNotifications), this._settings.PullInterval);
            }
        }
    }

    private _onCloseSession(): void {

        //console.debug(this.id + " - onCloseSession");

        if (this._pullIntervalHandle != null) {
            //console.debug(this.id + " - STOP pull Interval");
            clearInterval(this._pullIntervalHandle);
            this._pullIntervalHandle = null;
        }
    }



    setConfig(config: NotificationTypes.PullRequestData): void {
        if (typeof (config) != "undefined" && config != null) {
            this._requestData = config;
        }
    }




    // Dojo-Setter und Getter
   
    //_setInitialConfigAttr(initialConfig?: Notifications_PullRequestData): void {
    //    if (typeof (initialConfig) != "undefined" && initialConfig != null) {
    //        this._requestData = initialConfig;
    //    }

    //}

    protected _setupSubscriptions(): void {
        //this._topics.push(topic.subscribe("/Session/Open", lang.hitch(this, this._onOpenSession))); // 
        this._topics = [];
        // /Session/Close  - bei Logout
        // /Session/CurrentSessionData - kommt immmer wenn die SessionInfo die aktuellen Daten erhält
        // /Session/Open - kommt nur bei Login, also nach Seitenwechsel blöd.
        // /Session/CheckForExistingSession - immer wenn Sessioninfo einmal nach geöffneter Session gefragt hat und Daten erhält
        
        this._topics.push(topic.subscribe("/Session/CheckForExistingSession", lang.hitch(this, this._onSessionData)));
        this._topics.push(topic.subscribe("/Session/Close", lang.hitch(this, this._onCloseSession)));
        this._topics.push(topic.subscribe(NotificationTopics.Updated_Single, lang.hitch(this, this._onUpdatedNotification)));
    }


    postCreate(): void {
        super.postCreate.apply(this, arguments as any);


        if (window.notificationListener && window.notificationListener.id != this.id) {
            // falls eins zu viel erstellt werden sollte? alles abbrechen und mich selber zerstören.
            setTimeout(lang.hitch(this, this.destroy), 2000);
            return;
        } else {
            window.notificationListener = this;

            this._requestData = {
                earliestDate: null,
                includeConfirmed: true,
                includeExpired: false,
                includeRead: true
            }


            this.requestManager = new RequestManager();
            this.requestManager.handleAs = "jsonWithDate";

            this.allLoadedNotifications = [];

            this._setupSubscriptions();

            let settings = FeatureHelpers.getModule<NotificationTypes.ModuleSettings>("Notifications");
            if (settings) {
                this._settings = settings as any;
            }
        }

    }

    startup(): void {
        super.startup.apply(this, arguments as any);

       
    }

    destroy(args?: any): void {

        if (this._pullIntervalHandle != null) {
            clearInterval(this._pullIntervalHandle);
            this._pullIntervalHandle = null;
        }

        for (let handle of this._topics) {
            handle.remove();
        }

        super.destroy.apply(this, arguments as any);
    }

}

export default mdsWidget(NotificationListener);